import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { EntryService } from 'src/app/services/entry.service';
import { IEntryInnovation } from 'src/rest-interfaces/ueber-uns/IEntryInnovation';
import { ActivatedRoute } from '@angular/router';
import { LocaleService } from 'src/app/localization/locale.service';
import { ILocalizedComponent } from 'src/app/ILocalizedComponent';
import { generalAnimations } from 'src/app/_animations/general.animations';
import { SliderConfigService } from 'src/app/services/slider-config.service';
import { LightboxService } from 'src/app/services/lightbox.service';

@Component({
  selector: 'app-innovation',
  templateUrl: './innovation.component.html',
  animations: [generalAnimations]
})
export class InnovationComponent implements ILocalizedComponent {
  public content: IEntryInnovation;
  public currentSlide: number = 0;

  constructor(
    private entrySvc: EntryService,
    private localeSvc: LocaleService,
    private route: ActivatedRoute,
    private title: Title,
    public SliderConfigSvc: SliderConfigService,
    public lightboxSvc: LightboxService,
  ) {
    this.route.url.subscribe(
      () => {
        this.entrySvc.customControllerUri<IEntryInnovation>(
          this.localeSvc.RouterUri
        ).subscribe(
          t => {
            this.content = t;
            this.title.setTitle('PIRMIN JUNG - ' + (typeof t.metaTitle === 'string' && t.metaTitle.length > 0 ? t.metaTitle : t.title));
          },
          () => { this.localeSvc.navigateToHome(); }
        );
      }
    );
  }

  public getLocaleChangeUrl(targetLocale: string): string {
    const locUrlProperty = 'url_' + targetLocale;
    if (this.content && this.content.hasOwnProperty(locUrlProperty)) {
      return this.content[locUrlProperty];
    }
  }

  public afterChange(event: Event) {
    this.currentSlide = (event as any).currentSlide;
  }

  public showInLightBox(bilder) {
    this.lightboxSvc.setLightboxContent(bilder, this.currentSlide);
  }

  public getGridCssCellClasses( i: number ): string {

    const rowNoL = Math.floor( i / 2 ) + 1;
    const colNoL = i % 2;
    const rowNoXL = Math.floor( i / 3 ) + 1;
    const colNoXL = i % 3;

    const colStartL = Math.floor( colNoL * 12 ) + 2;
    const colEndL = colStartL + 10;

    const colStartXL = Math.floor( colNoXL * 8 ) + 2;
    const colEndXL = colStartXL + 6;

    const gridClasses = [
      'row-s-' + ( i + 1 ).toString(),
      'col-s-3-22',
      'row-l-' + rowNoL,
      'col-l-' + colStartL.toString() + '-' + colEndL.toString(),
      'row-xl-' + rowNoXL,
      'col-xl-' + colStartXL.toString() + '-' + colEndXL.toString(),
    ];

    return gridClasses.join( ' ' );
  }
}